import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Input, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { BaseAccountInfoComponent } from '../../components/BaseAccountInfo/BaseAccountInfo.component';
import { LoggingService } from '../../services/logging.service';
import { AccountInfoService } from './../../services/account-info.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent
  extends BaseAccountInfoComponent
  implements OnInit
{
  @Input() appTitle: string = '';

  name: string | unknown;
  email: string | unknown;
  issues: any[] = [];
  sessionUrl: string = '';
  isReportBugModalVisible: boolean = false;
  canReport: boolean = environment.useLogRocket;

  constructor(
    private clipboard: Clipboard,
    private msalService: MsalService,
    protected override accountInfoService: AccountInfoService,
    private loggingService: LoggingService
  ) {
    super(accountInfoService);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.email = this.accountInfo?.username;
    this.name = this.accountInfo?.name; // Fallback to account info if available
  }

  reportBug() {
    this.sessionUrl = this.loggingService.getSessionUrl();
    this.isReportBugModalVisible = true;
  }

  copyToClipboard() {
    this.clipboard.copy(this.sessionUrl);
    alert('URL copied to clipboard!'); // Optional: Notify the user
  }

  logout() {
    this.msalService.logoutRedirect();
  }
}
